import {createHash} from "crypto";

interface itemProps {
  item_id: string | undefined
  item_name: string | undefined
  item_category?: string
  item_variant?: string
  item_brand?: string
  item_list_name?: string
  item_list_id?: string
  index?: number
  item_location_id?: string
  price: number | undefined
  currency: 'IDR'
  quantity: number
  item_url?: string
  item_image_url?: string
}

interface checkoutParamsProps {
  currency: 'IDR'
  value?: number
  coupon?: string
  items: itemProps[]
}

interface addPaymentInfoProps extends checkoutParamsProps {
  payment_type: "BANK_TRANSFER" | "EWALLET" | "CREDIT_CARD" | "PAY_LATER",
  payment_method?: string
}

interface userDataProps {
  user_id?: string
  user_email?: string
  user_phone?: string
  user_firstname?: string
  user_lastname?: string
}

const hash = (str: string | undefined) => {
  if (typeof str !== "undefined") {
    return createHash('sha256').update(str).digest('hex')
  }
}

export const pushDataLayerUser = (data: userDataProps) => {
  if (typeof window !== "undefined") {
    window.dataLayer.push(data)
  }
}

export const trackCustomEvent = (eventName: string, params: object) => {
  if (typeof window !== "undefined") {
    window.gtag("event", eventName, params)
  }
}


export const trackViewItem = (params: itemProps) => {
  if (typeof window !== "undefined") {
    window.gtag("event", "hsl_view_item", params)
  }
}

export const trackAddToCart = (params: itemProps, user?: userDataProps) => {
  if (typeof window !== "undefined") {
    window.gtag("event", "hsl_add_to_cart", params)
    window.fbq("track", "AddToCart", {
      content_type: "product",
      content_ids: [params.item_id],
      value: params.price,
      currency: "IDR",
      contents: [
        {
          id: params.item_id,
          quantity: params.quantity
        }
      ],
      num_items: params.quantity,
      user_data: {
        external_id: hash(user?.user_id),
        em: hash(user?.user_email),
        ph: hash(user?.user_phone),
        fn: hash(user?.user_firstname),
        ln: hash(user?.user_lastname),
      }
    })
  }
}

export const trackRemoveFromCart = (params: itemProps) => {
  if (typeof window !== "undefined") {
    window.gtag("event", "hsl_remove_from_cart", params)
  }
}

export const trackBeginCheckout = (params: checkoutParamsProps, user?: userDataProps) => {
  if (typeof window !== "undefined") {
    window.gtag("event", "hsl_begin_checkout", params)
    window.fbq("track", "InitiateCheckout", {
      content_category: "product",
      content_type: "product",
      content_ids: params.items.map((item) => item.item_id),
      value: params.value,
      currency: "IDR",
      contents: params.items.map((item) => {
        return {id: item.item_id, quantity: item.quantity}
      }),
      user_data: {
        external_id: hash(user?.user_id),
        em: hash(user?.user_email),
        ph: hash(user?.user_phone),
        fn: hash(user?.user_firstname),
        ln: hash(user?.user_lastname),
      }
    })
  }
}

export const trackAddPaymentInfo = (params: addPaymentInfoProps, user?: userDataProps) => {
  if (typeof window !== "undefined") {
    window.gtag("event", "hsl_add_payment_info", params)
    window.fbq("track", "AddPaymentInfo", {
      content_category: "product",
      content_type: "product",
      content_ids: params.items.map((item) => item.item_id),
      value: params.value,
      currency: "IDR",
      contents: params.items.map((item) => {
        return {id: item.item_id, quantity: item.quantity}
      }),
      user_data: {
        external_id: hash(user?.user_id),
        em: hash(user?.user_email),
        ph: hash(user?.user_phone),
        fn: hash(user?.user_firstname),
        ln: hash(user?.user_lastname),
      }
    })
  }
}